export const filterConstants = {
  Accept: "Accept",
  Pending: "Pending",
  Reject: "Reject",
  All: "All",
  Appeal: "Appeal",
  Processing: "Processing",
  Rejected: "Rejected",
  Submitted: "Submitted",
  Accepted: "Accepted",
  Approved: "Approved",
  Utilized: "Utilized",
  receive: "receive",
  Active: "Active",
  Inactive: "Inactive",
  inActive: "inActive",
  Yes: "Yes",
  No: "No",
  Select: "Select",
  Unutilized: "Unutilized",
  UtilizationDate: "Utilization Date",
  RedemptionDate: "Redemption Date",
};

export const mobileConstraints = {
  mobileMin: 8,
  mobileMax: 12,
};

export const memberMobileConstraints = {
  mobileMin: 8,
  mobileMax: 15,
};

export const SearchToolTip = {
  Receipts: "Search by receipt number, loyalty card number",
  FinanceReports: "Search by Report name",
  Merchants: "Search by Merchant, Company Name, Unit Number",
  Voucher:
    "Search by Voucher title, Loyalty Card number, Order ID, Transaction ID, Serial Number",
  VoucherMember:
    "Search by Voucher title, Order ID, Transaction ID, Serial Number",
  VoucherReimb: "Search by Report ID, Merchant, Company Name",
  SalesListing: "Search by  Order ID , Transaction No, Loyalty Card No",
  SalesDetails: "Search by  Loyalty Card No , Item Name, Merchant",
  VoucherDetails: "Search by Voucher Serial Number",
  EvoucherDetails:
    "Search by Transaction code, E-Voucher Title, E-Voucher Code",
  Users: "Search by, First Name, Last Name and email",
  ShopUsers: "Search by Name and email",
  PVoucher: "Search by Voucher number,Sold To",
  MerchantVoucher:
    "Search by Loyalty card number, Voucher Serial Number, Voucher Title, Transaction ID",
  MerchantVoucherReImb: "Search by Report ID",
  Sales: "Search by Title",
  LoyaltyPoints: "Search by Campaign Name/Merchant and Remark",
  MemberReceipts: "Search by Receipt Number",
  CarParkLog: "Search by Reward Name, IU Number, License Plate",
  MerchantShopUser:
    "Search by Name, Email, Mobile Number, Merchant, Company Name",
  MerchantReceipts: "Search by receipt number, loyalty card number",
  CorporateLogs:
    "Search by Member Name, Access ID, Corporate Email,Suntec+ Email, Mobile Number",
};

export const modelName = {
  utilizedVouchers: "utilized-vouchers-suntec",
  reimbursementReport: "reimbursement-report-suntec",
  physicalVoucher: "physical-vouchers-suntec",
  physicalVoucherDetails: "physical-voucher-details-suntec",
  paymentGatewayOrder: "payment-gateway-order",
  merchantReceiptSuntec: "merchant-receipt-suntec",
  receiptSuntec: "receipt-suntec",
};
export const hashKey = {
  campaignType: "campaignType",
  placeholderId: "placeholder_id",
  orderId: "order_id",
  reportId: "report_id",
};
export const hashValue = {
  event: "event",
  allRecords: "ALL-RECORDS",
};

export const permissionsConstants = {
  admin: "admin",
  shop_user: "shop_user",
  access_management: "access_management",
  user: "user",
  flash_sale: "flash_sale",
  all_flash_sales: "all_flash_sales",
  active_flash_sales: "active_flash_sales",
  dashboard: "dashboard",
  physical_voucher_reimbursement: "physical_voucher_reimbursement",
  promotions: "promotions",
  all_promotions: "all_promotions",
  active_promotions: "active_promotions",
  rewards: "rewards",
  all_rewards: "all_rewards",
  active_rewards: "active_rewards",
  evoucher_reimbursement: "evoucher_reimbursement",
  user_access: "user_access",
  voucher_transaction: "voucher_transactions",
  member_redemption: "member_redemption",
  evouchers: "evouchers",
  receipts: "receipts",
  points: "points",
  members: "members",
  carpark_logs: "carpark_logs",
  members_search: "members_search",
  corporate_member_logs: "corporate_member_logs",
  merchant: "merchant",
  merchants: "merchants",
  sale_of_voucher: "sale_of_voucher",
  sales: "sales",
  finance: "finance",
  sales_listing: "sales_listing",
  physical_voucher: "physical_voucher",
  reimbursment_physical_voucher: "reimbursment_physical_voucher",
  fraud_detect_configuration: "fraud_detect_configuration",
  reimbursment_evoucher: "reimbursment_evoucher",
  finance_reports:"finance_reports"
};

export const DateConstants = {
  maxDate: "9999-12-31",
};

export const errorMessageConstants = {
  remarkMessage: "Remarks must be 50 characters or fewer",
  pvRemarkMessage: "Only 15 characters allowed",
  pvExpiryErrorMessage: "Expiry date must not precede issue date",
  pvAmountErrorMessage: "Maximum amount allowed is S$10000",
  sameEmailError:"New email same as Old email",
  notSameEmailError:"Emails do not match"
};

export const carParkFilter: {[key: string]: string} = {
  utilised: "Utilised",
  expired: "Expired",
  redeemed: "Redeemed",
  migration:"Migration",
  vehicleActivated: "Vehicle Activated",
  vehicleDeactivated: "Vehicle Deactivated",
  vehicleAdded: "Vehicle Added",
  vehicleDeleted: "Vehicle Deleted",
};
